import { Api } from './BaseApi'
import { IProject } from '../../types/Project/IProject';
import { IProjectType } from '../../types/Project/IProjectType';
import { IWorkstream } from '../../types/Gameplan/IWorkstream';
import IForm from '../../types/Form/IForm';
import { IFormConfig } from '../../types/Form/IFormConfig';
import { IProjectAssignment } from '../../types/Project/IProjectAssignment';
import { ISLA } from '../../types/ISLA';

const ProjectApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getProjectList: build.query<IProject[], number>({
            query: (companyId) => "Project/?companyId=" + companyId,
            providesTags: ["ProjectList"],
        }),
        getProjectTypeList: build.query<IProjectType[], void>({
            query: () => "Project/Type",
            providesTags: ["ProjectTypeList"],
        }),
        getWorkstreams: build.query<IWorkstream[], number>({
            query: (id) => `Project/${id || 0}/Workstream`,
            providesTags: ["GetWorkstreams"],
        }),
        getProject: build.query<IProject, number>({
            query: (Id) => `Project/${Id}`,
            providesTags: ["GetProject"],
        }),
        getForm: build.query<IForm, number>({
            query: (formId) => {
                return `Form/${formId}/`;
            },
            providesTags: ["FormByProject"],
        }),
        getFormConfig: build.query<IFormConfig, void>({
            query: () => `Form/Config`,
            providesTags: ["FormConfig"],
        }),
        getProjectAssignment: build.query<IProjectAssignment[], number>({
            query: (projectId) => `Project/${projectId}/Assignment`,
            providesTags: ["GetProjectAssignment"],
        }),
        getFormByProject: build.query<
            IForm,
            { projectId: number; companyId?: number; locationId?: number }
        >({
            query: ({ projectId, companyId, locationId }) => {
                console.log("locationId", locationId);
                if (companyId)
                    return `Form/ByProject/${projectId}/${companyId}/${locationId | 0}`;
                else return `Form/ByProject/${projectId}`;
            },
            providesTags: ["FormByProject"],
        }),
        getSLAList: build.query<ISLA[], { projectId: number; priorityId: number }>({
            query: ({ projectId, priorityId }) =>
                "SLA/?projectId=" + projectId + "&priorityId=" + priorityId,
            providesTags: ["SLAList"],
        }),
    }),

    overrideExisting: true,
})

export { ProjectApi };